import { render, staticRenderFns } from "./NKWChangedNKWsTable.vue?vue&type=template&id=0a4524a2&scoped=true&"
import script from "./NKWChangedNKWsTable.vue?vue&type=script&lang=js&"
export * from "./NKWChangedNKWsTable.vue?vue&type=script&lang=js&"
import style0 from "./NKWChangedNKWsTable.vue?vue&type=style&index=0&id=0a4524a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4524a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
